const navDataTest = {
    hamburgerNav: 'main-nav-hamburger',
    navItem: 'main-nav-item-',
    serviceNavItem: 'service-nav-item-',
}

export default navDataTest